<template>
  <div id="health-list" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
		<div class="sav-container">
      <Header title="Ασφάλειες Υγείας" search="true"/>
      <Table v-if="tableRows" category="health" :tableHeaders="tableHeaders" :tableRows="tableRows"/>
      <ErrorMsg v-if="errorMsg" :msg="errorMsg"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './../Spinner.vue'
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import Table from './../Table.vue'
import ErrorMsg from './../ErrorMsg.vue'
import healthHeaders from './../../../public/data/db.health-headers.json'

export default {
  components: {
    Spinner,
    Topbar,
    Header,
    Table,
    ErrorMsg
  },
  data() {
    return {
      isLoading: true,
      apiUrl : this.$parent.apiUrl,
      headerTitle: 'Υγεία',
      tableHeaders: healthHeaders,
      tableRows: '',
      errorMsg: ''
    }
  },
  methods : {
    scrollToLastClickedRow(hash){
      setTimeout(function(){ 
        try {
          let el = document.getElementById(hash.replace('#', ''));
          if (el) el.scrollIntoView();
        } catch(err) {
          console.log(err)
        }
      }, 700);
    }
  },
  mounted () {
    const vm = this;
    let formData = {
      user: JSON.parse(localStorage.getItem('sav-erp-user')),
      token: this.$cookie.get('sav-erp-token'),
      refreshToken: this.$cookie.get('sav-erp-refresh-token')
    };

    let headers = { 
			headers: {
			'Content-type': 'application/json',
			}
    };

    axios.post(this.apiUrl + '/get/health', formData, headers)
      .then(response => {
        vm.isLoading = false;
        if (response.status == 200) {
          this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
          vm.errorMsg = '';
          vm.tableRows = response.data.data;
          vm.scrollToLastClickedRow(vm.$route.hash);  
        } else {
					vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
				}
      })
      .catch(error => {
        let response = error.response;
        
        if (!response) {
          vm.errorMsg = "Μη ενεργός server";
        } else {
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
        }
        vm.isLoading = false;
      });
  }
}
</script>

<style lang="scss" scoped>
</style>
